import { render, staticRenderFns } from "./StockAdjustmentDetail.vue?vue&type=template&id=76af31f4"
import script from "./StockAdjustmentDetail.vue?vue&type=script&lang=ts"
export * from "./StockAdjustmentDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports